import t9n from "@bimproject/t9n";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import ComponentTypeCardContainer from "./ComponentTypeCardContainer";
import { useSuspenseBIMClass } from "../../../../../../clients/taxonomy/useBIMClass";
import { useFinder } from "../../../../../../modules/finder";

export default function ComponentTypeFinderPlugin(props) {
    const { Component = ComponentTypeCardContainer, bimClassID, id, onSelect } = props;

    const { token } = useFinder();

    const bimClass = useSuspenseBIMClass(bimClassID).data?.bimClass;

    const { i18n } = useTranslation();

    const componentTypes = useMemo(
        () => (bimClass?.data?.componentTypes ?? [])
            .filter(
                (componentType) => [
                    componentType.id.replaceAll("-").toLowerCase() === token.replaceAll("-").toLowerCase(),
                    token.length > 3 && componentType.id.replaceAll("-").toLowerCase().includes(
                        token.replaceAll("-").toLowerCase()
                    ),
                    componentType.name
                        .map((translatable) => translatable.text)
                        .map((text) => text.toLowerCase())
                        .some((text) => text.includes(token.toLowerCase())),
                ].some(Boolean)
            )
            .sort(
                (a, b) => t9n(a.name, i18n.language).localeCompare(t9n(b.name, i18n.language)),
            ),
        [bimClass?.data?.componentTypes, token],
    );

    return componentTypes.map(
        (componentType) => (
            <Component
                bimClassID={ bimClassID }
                id={ componentType.id }
                key={ componentType.id }
                onClick={ () => onSelect(componentType.id) }
                selected={ id === componentType.id }
            />
        )
    );
}
